(function () {


    $questions = document.querySelectorAll('.faq-component .question');

    $questions.forEach(function (question) {
        question.addEventListener('click', function () {

            question.parentElement.querySelector('.answer').classList.toggle('is-open');

        });
    });


})();
